<template>
  <div :id="itemModel.vars.id" ref="radioGroup" class="form-radio-container">
    <label
      v-if="itemModel.vars.label"
      :class="
        'form-label' +
        (itemModel.vars.label_attr && itemModel.vars.label_attr.class ? ' ' + itemModel.vars.label_attr.class : '') +
        (itemModel.vars.required ? ' required' : '')
      "
    >
      {{ index ? index + ". " : "" }}{{ itemModel.vars.label }}{{ itemModel.vars.required ? "*" : "" }}
      <span v-if="itemModel.vars.help && !isMobile()" v-tooltip="{ title: itemModel.vars.help, textWrap: true }">
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
      </span>
      <button
        v-if="itemModel.vars.value && !itemModel.vars.required"
        v-tooltip="{ title: $t('reset') }"
        class="btn btn-icon"
        type="button"
        @click="resetChoice"
      >
        <FontAwesomeIcon icon="fa-light fa-rotate-right" />
      </button>
    </label>
    <div v-if="isMobile() && itemModel.vars.help" class="form-info">
      <FontAwesomeIcon icon="fa-light fa-circle-question" />
      {{ itemModel.vars.help }}
    </div>
    <div v-if="!itemModel.vars.hide" :class="itemModel.direction ? itemModel.direction : ''">
      <div
        v-for="choice in itemModel.vars.choices"
        :key="choice.value"
        :class="
          'text-color radio-primary custom-control custom-radio' +
          (choice.attr && choice.attr['data-class'] ? ' ' + choice.attr['data-class'] : '') +
          (choice.attr && choice.attr['data-type'] ? ' --' + choice.attr['data-type'] : '')
        "
      >
        <input
          :id="
            'radio-' +
            itemModel.vars.name +
            (itemModel.vars.toggler_target ? itemModel.vars.toggler_target : '') +
            '-' +
            choice.value
          "
          v-model="itemModel.vars.value"
          :class="
            (itemModel.vars.error ? 'custom-control-input is-invalid' : 'custom-control-input') +
            (itemModel.vars.attr && itemModel.vars.attr.class ? ' ' + itemModel.vars.attr.class : '')
          "
          :disabled="itemModel.vars.disabled === true"
          :name="itemModel.vars.name + (itemModel.vars.toggler_target ? itemModel.vars.toggler_target : '')"
          :value="choice.value"
          type="radio"
          @change="valid($event)"
          @focus="focus"
        />
        <label
          :for="
            'radio-' +
            itemModel.vars.name +
            (itemModel.vars.toggler_target ? itemModel.vars.toggler_target : '') +
            '-' +
            choice.value
          "
          :class="
            'custom-control-label ' +
            (itemModel.vars.disabled === true ? 'input__disabled' : '') +
            (choice.attr && (choice.attr['data-description'] || choice.attr['data-type'])
              ? ' choice-label--detailed'
              : '')
          "
        >
          <span class="choice-content">
            <span class="choice-title-row">
              <template v-if="choice.attr && choice.attr['data-icon'] && choice.attr['data-icon'].length">
                <span class="choice-icon">
                  <FontAwesomeIcon v-if="choice.attr['data-icon']" :icon="'fa-light fa-' + choice.attr['data-icon']" />
                </span>
              </template>
              <span
                v-else-if="choice.attr && choice.attr['data-type']"
                :class="'choice-dot bg-' + choice.attr['data-type']"
              ></span>
              <span>{{ choice.label }}</span>
            </span>
            <span v-if="choice.attr && choice.attr['data-description']" class="choice-subtitle">
              {{ choice.attr["data-description"] }}
            </span>
          </span>
        </label>
      </div>
    </div>
  </div>
  <div v-if="model.vars.error" :class="'invalid-feedback d-block' + (model.vars.row ? ' text-center' : '')">
    {{ model.vars.error }}
  </div>
</template>

<script>
import { formValidator } from "@/services/form/form-validator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "RadioTypeComponent",
  components: { FontAwesomeIcon },
  props: {
    model: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
  },
  emits: ["draft", "update", "toggle", "focus"],
  data() {
    return {
      itemModel: this.model,
      key: 0,
    };
  },
  watch: {
    "model.vars.value"() {
      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
    },
    "model.vars.error"() {
      this.getClass();
    },
  },
  methods: {
    valid(event) {
      this.itemModel.vars.value = event.target.value;
      this.$emit("update", this.itemModel.vars.value);
      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
      this.$emit("draft", this.itemModel);

      formValidator.validModel(this.itemModel);
      this.getClass();
    },
    getClass() {
      this.key++;
      const group = document.getElementById(this.itemModel.vars.id);
      const targets = group.querySelectorAll(".custom-control-input");
      if (!this.itemModel.vars.value || (this.itemModel.vars.value && !this.itemModel.vars.value.toString().length)) {
        for (let i = 0; i < targets.length; i++) {
          targets[i].classList.add("is-invalid");
        }
      } else {
        for (let i = 0; i < targets.length; i++) {
          targets[i].classList.add("is-valid");
        }
      }
    },
    isMobile() {
      return window.innerWidth < 992;
    },
    focus() {
      this.$emit("focus");
    },

    resetChoice() {
      this.itemModel.vars.value = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-radio {
  padding: 15px;
  border: 2px solid $dark-grey;
  border-radius: $radius;
  margin: 10px 0;

  &-container {
    width: 100%;
  }
}

.input__disabled {
  cursor: not-allowed;

  &:before,
  &:after {
    cursor: not-allowed;
  }
}

.form-radio-row {
  display: flex;

  div + div {
    margin-left: 15px;
  }
}

.is-invalid + label {
  &:before {
    border-color: $red;
  }
}

.btn-icon {
  svg {
    height: 15px;
    width: 15px;
  }
}

.form-label {
  display: flex;
}

.choice-label--detailed {
  display: flex;
  align-items: flex-start;
}

.choice-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.choice-title-row {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 600;
  width: 100%;
  text-align: center;
}

.choice-subtitle {
  color: $dark-grey;
  font-size: 13px;
  width: 100%;
  text-align: center;

  @include dark-theme {
    color: $light-grey;
  }
}

.choice-icon,
.choice-dot {
  width: 20px;
  min-width: 20px;
  height: 20px;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.choice-icon {
  margin-bottom: 8px;
}

.choice-dot {
  border-radius: 50%;
  margin-bottom: 8px;
}

.radio-card {
  display: inline-block;
  width: 24%;
  padding-left: 0;

  @include up-to-lg {
    width: 100%;
  }

  &.--warning {
    --radio-card-color: #f8a007;
    --radio-card-bg-color: #fff9ed;
  }

  &.--success {
    --radio-card-color: #27856e;
    --radio-card-bg-color: #ddf5f0;
  }

  &.--danger {
    --radio-card-color: #ce465f;
    --radio-card-bg-color: #fff5f5;
  }

  &.--info {
    --radio-card-color: #546bd1;
    --radio-card-bg-color: #e7f7ff;
  }

  &.--primary {
    --radio-card-color: #00275e;
    --radio-card-bg-color: #eaf1ff;
  }

  input {
    display: none;
  }

  .custom-control-label {
    width: 100%;
    padding-left: 0;
    border: 2px solid transparent;
    border-radius: $radius;
    background: $bg-grey;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    max-height: 100px;
    height: 100px;

    @include dark-theme {
      background: $m-color_12;
    }

    &:before,
    &:after {
      display: none;
    }
  }

  input:checked + .custom-control-label,
  .custom-control-label:hover {
    border: 2px solid var(--radio-card-color);
    background: var(--radio-card-bg-color);

    @include dark-theme {
      background: $m-color_12;
    }

    .choice-title-row,
    .choice-icon svg {
      @include dark-theme {
        color: $white !important;
      }
    }
  }
}

.radio-card + .radio-card {
  margin-left: 1%;

  @include up-to-lg {
    margin-left: 0;
    margin-top: 8px;
  }
}
</style>
